<template>
  <PumpsCollectionPage />
</template>

<script setup lang="ts">
import PumpsCollectionPage from '../../pumps/index.vue'
</script>
